const ITTicketsTab = ({ itTickets, setSelectedEquipment, setShowTicketModal, darkMode }) => {
  const getStatusConfig = (status) => {
    const configs = {
      'open': { label: 'Aberto', color: darkMode ? 'bg-amber-900/30 text-amber-400' : 'bg-amber-100 text-amber-700' },
      'in_progress': { label: 'Em Progresso', color: darkMode ? 'bg-blue-900/30 text-blue-400' : 'bg-blue-100 text-blue-700' },
      'resolved': { label: 'Resolvido', color: darkMode ? 'bg-emerald-900/30 text-emerald-400' : 'bg-emerald-100 text-emerald-700' },
      'closed': { label: 'Fechado', color: darkMode ? 'bg-slate-700/50 text-slate-400' : 'bg-slate-200 text-slate-600' }
    };
    return configs[status] || { label: status, color: darkMode ? 'bg-slate-700/50 text-slate-300' : 'bg-slate-200 text-slate-600' };
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h3 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>Tickets de Suporte IT</h3>
        <button
          onClick={() => { setSelectedEquipment(null); setShowTicketModal(true); }}
          className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-500 transition-colors"
          data-testid="create-ticket-btn"
        >
          + Novo Ticket
        </button>
      </div>
      
      {itTickets.length === 0 ? (
        <div className="text-center py-8">
          <p className={`mb-4 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Sem tickets de suporte</p>
          <button
            onClick={() => setShowTicketModal(true)}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-500"
          >
            Criar Primeiro Ticket
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          {itTickets.map((ticket, idx) => {
            const status = getStatusConfig(ticket.status);
            return (
              <div key={idx} className={`p-4 rounded-lg flex items-center justify-between ${darkMode ? 'bg-slate-700/50' : 'bg-slate-100'}`}>
                <div>
                  <p className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>{ticket.title}</p>
                  <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{ticket.description?.substring(0, 80)}...</p>
                  {ticket.equipment_info && (
                    <p className={`text-xs mt-1 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      Equipamento: {ticket.equipment_info.brand} {ticket.equipment_info.model}
                    </p>
                  )}
                  <p className={`text-xs mt-1 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                    Criado: {new Date(ticket.created_at).toLocaleDateString('pt-PT')}
                  </p>
                </div>
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${status.color}`}>
                  {status.label}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ITTicketsTab;
